import React, { useState } from 'react';
import { InputAdornment, TextField, FormControl } from '@material-ui/core';
import { VisibilityOff, Visibility } from '@material-ui/icons';
import * as lib from '~/dependencies';
import { IconButtonStyled, BoxErrors, Container } from './styles';

export default function InputLogin({
  label,
  placeholder,
  value,
  onChange,
  password,
  name,
  validator,
  loading,
  onKeyPress,
  ...rest
}) {
  const [showPassword, setShowPassword] = useState(false);
  const errorValues = validator || [];
  const isError = !!errorValues.find(e => e.field === name) || false;

  return (
    <Container validator={isError}>
      <FormControl className="controlForm">
        <span className="label">{label}</span>
        {password ? (
          <TextField
            {...rest}
            autoComplete="on"
            placeholder={placeholder}
            value={value}
            disabled={loading}
            className="auth-input"
            onChange={text =>
              onChange({ field: name, value: text.target.value })
            }
            type={showPassword ? 'text' : 'password'}
            onKeyPress={e => onKeyPress(e)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButtonStyled
                    edge="end"
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    className="fix-adornment">
                    {showPassword ? (
                      <VisibilityOff className="icon" />
                    ) : (
                      <Visibility className="icon" />
                    )}
                  </IconButtonStyled>
                </InputAdornment>
              ),
            }}
          />
        ) : (
          <TextField
            {...rest}
            autoComplete="on"
            placeholder={placeholder}
            disabled={loading}
            value={value}
            className="auth-input"
            onChange={text =>
              onChange({ field: name, value: text.target.value })
            }
          />
        )}
      </FormControl>
      <BoxErrors>
        {errorValues &&
          errorValues
            .filter(e => e.field === name)
            .map(e => <span key={e.field}>{e.message}</span>)}
      </BoxErrors>
    </Container>
  );
}

InputLogin.defaultProps = {
  label: '',
  placeholder: '',
  value: '',
  password: false,
  loading: false,
  onChange: () => {},
  onKeyPress: () => {},
  validator: [],
};

InputLogin.propTypes = {
  name: lib.PropTypes.string.isRequired,
  label: lib.PropTypes.string,
  value: lib.PropTypes.string,
  placeholder: lib.PropTypes.string,
  onChange: lib.PropTypes.func,
  onKeyPress: lib.PropTypes.func,
  password: lib.PropTypes.bool,
  loading: lib.PropTypes.bool,
  validator: lib.PropTypes.instanceOf(Object),
};
